import { ControlLabelsContext } from "@controls";
import { useComboboxLabels } from "@src/hooks/use-combobox-labels";
import { ReactNode } from "react";

/**
 * Supplies translated Combobox/Select UI strings (search, empty, loading,
 * toolbar, etc.) to every control beneath it, so they localize without a
 * `labels` prop at each call site.
 */
export function ControlLabelsProvider({ children }: { children: ReactNode }) {
  return (
    <ControlLabelsContext.Provider value={useComboboxLabels()}>
      {children}
    </ControlLabelsContext.Provider>
  );
}

export default ControlLabelsProvider;
